import { useCurrentUserStorage } from '@pn/core/storage';
import { isCordova } from '@pn/core/utils/env';
import { isImpersonating } from '@pn/core/utils/impersonate';
import { hashSHA256 } from '@pn/services/utils/hash';
import { isNil } from 'lodash-es';
import React from 'react';

declare global {
  interface Window {
    Beamer: any;
    beamer_config: any;
  }
}

export const beamerButtonId = 'beamerButton';

export type BeamerConfigId = 'intel' | 'maps';

const beamerConfigs: Record<BeamerConfigId, any> = {
  intel: {
    filter: 'Intel',
  },
  maps: {
    filter: 'Maps',
    bounce: false,
    right: 0,
    left: 20,
  },
};

/**
 * Invoked in BeamerButton component.
 */
export function useAutoInitializeBeamer(configId: BeamerConfigId): void {
  const hasRun = React.useRef(false);

  const { user, isUserLoaded } = useCurrentUserStorage();

  React.useEffect(() => {
    if (hasRun.current || isCordova() || !isUserLoaded || isImpersonating()) {
      return;
    }

    hasRun.current = true;

    (async () => {
      window.beamer_config = {
        product_id: 'KnkPzbci73087',
        user_id: !isNil(user) ? await hashSHA256(user.email) : undefined,
        multi_user: true,
        selector: beamerButtonId,
        logs: false, // disable console logs
        ...beamerConfigs[configId],
      };

      const script = document.createElement('script');
      script.src = 'https://app.getbeamer.com/js/beamer-embed.js';
      document.head.appendChild(script);
    })();
  }, [configId, isUserLoaded, user]);
}
